
export enum RuleFailureReasonCd {
	SRN_NOT_ENTERED = 'SrnNotEntered',
	SRN_NOT_VALID = 'SrnNotValid'}

